import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { staticDataQuery, staticDataQuery_system } from '../../core-types';

// this data is considered static, and will only be fetched from core on build
export const STATIC_DATA_QUERY = gql`
  query staticDataQuery {
    system {
      id
      timezone
      colourKey
      currency
      defaultLanguageCode
      languageCodes
      sanityProjectId
      sanityDataset
      cityName
      contactEmail
      usersCanUnlockWithPinCode
      registrationEnabled
    }
    phoneVerificationCodeLength
  }
`;

export const useStaticDataQuery = (
  options?: QueryHookOptions<staticDataQuery>
) => useQuery<staticDataQuery>(STATIC_DATA_QUERY, options);

export function useStaticDataSystem(
  options?: QueryHookOptions<staticDataQuery>
): staticDataQuery_system {
  const { data } = useStaticDataQuery(options);
  if (!data || !data.system) {
    throw new Error('Static data system not found');
  }
  return data.system;
}
